import axios from '../axios'

const getStudentSummary = (userId) =>
    axios.get(`api/teacher/payments/summary/${userId}`);

export default getStudentSummary